import { observer } from 'mobx-react-lite';
import ProposalSection, { ProposalSectionEditableProps } from './ProposalSection';
import { ProposalDto } from '@gap/backend/app-services/proposal/models/ProposalDto';
import Typography from "@mui/material/Typography"
import proposalExpectations from '@gap/utils/proposals/proposalExpectations';
import { useMemo } from 'react';

type ProposalSectionExpectationsProps = {
   proposal: ProposalDto,
   sectionProps?: ProposalSectionEditableProps,
}

export default observer(function ProposalSectionExpectations({ proposal, sectionProps }: ProposalSectionExpectationsProps) {
   const expectations = useMemo(() => {
      return (proposal.step4?.expectations || []).map((expectationId) => proposalExpectations.find(({ id }) => expectationId === id)?.name)
   }, [proposal.step4?.expectations])

   if (expectations.length === 0) return null

   return <ProposalSection
      heading="Expectations"
      subheading={`Expectations help to ensure an excellent working relationship between us and act as
               a two-way street. At a minimum, this includes:`}
      {...sectionProps}
   >
      <Typography variant="body1" component="ul">
         {expectations.map((expectation, index) => <li key={index}>{expectation}</li>)}
      </Typography>
   </ProposalSection>
})
